import React, { useReducer, useState, useEffect } from 'react';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import VendingService from '../services/VendingService';
import ResponseParser from '../util/ResponseParser';
import '../css/custom.css';
import 'bulma-divider/dist/css/bulma-divider.min.css';
import '../css/vending.css';
import CustomerCard from './CustomerCard';
import Notification from './Notification';
import Receipt from './Receipt';
import DashBoard from './DashBoard';
import { toast } from 'react-toastify';
import { handleApiError } from '../util/Errors';

const reducer = (state, action) => {
   switch (action.type) {
      case 'updateField':
         return { ...state, [action.payload.field]: action.payload.value };
      case 'validate':
         return {
            ...state,
            customerCheckResponse: action.payload.customerCheckResponse,
         };
      case 'vend':
         return {
            ...state,
            vendingResponse: action.payload.vendingResponse,
            notificationType: action.payload.notificationType,
            notification: action.payload.notification,
         };
      case 'reset':
         return {
            mobileNumber: '',
            meterNumber: '',
            amount: 0,
            customerCheckResponse: {},
            vendingResponse: {},
         };
      case 'resetReceipt':
         return {
            ...state,
            notificationType: action.payload.notificationType,
            vendingResponse: {},
         };
      default:
         return '';
   }
};

export default function Vending() {
   const [state, dispatch] = useReducer(reducer, {
      mobileNumber: '',
      meterNumber: '',
      amount: 0,
      customerCheckResponse: {},
      vendingResponse: {},
   });
   const [validated, setValidated] = useState();
   const [active, setActive] = useState(false);
   const [showReceipt, setShowReceipt] = useState(false);
   const [isValidateLoading, setIsValidateLoading] = useState(false);
   const [isBuyingLoading, setIsBuyingLoading] = useState(false);
   const savedUser = JSON.parse(sessionStorage.getItem('user'));
   const [agentAccount, setAgentAccount] = useState({});

   /**
    * method use to handle meter validation
    * @param {*} e
    */
   const handleValidate = (e) => {
      e.preventDefault();
      let request = { ...state };
      request.partnerId = savedUser.partnerId;
      setShowReceipt(false);
      setIsValidateLoading(true);
      setValidated(false);
      dispatch({
         type: 'resetReceipt',
         payload: {
            notificationType: '',
         },
      });
      if (!request.meterNumber || request.meterNumber === '') {
         let response = {};
         response.responseCode = -1;
         response.responseDesc = 'Error: Meter number details empty';
         setIsValidateLoading(false);
         setValidated(true);
         dispatch({
            type: 'validate',
            payload: {
               customerCheckResponse: response,
            },
         });
         setActive(false);
         return;
      }
      VendingService.validateMeter(request)
         .then((res) => res.text())
         .then((data) => {
            let response = ResponseParser.parseValidateResponse(data);
            setIsValidateLoading(false);
            setValidated(true);
            if (response.responseCode === 1) {
               setActive(true);
               toast.info('Successfully Validated', { autoClose: 4000, position: 'top-center' });
            } else {
               setActive(false);
            }
            dispatch({
               type: 'validate',
               payload: {
                  customerCheckResponse: response,
               },
            });
         })
         .catch((error) => {
            console.log(error);
            handleApiError(error);
         });
   };

   const handleReset = () => {
      dispatch({
         type: 'reset',
      });
      setActive(false);
      setValidated(false);
      setIsValidateLoading(false);
      setShowReceipt(false);
   };

   const updateField = (field, value) => {
      if (field === 'meterNumber') {
         setActive(false);
      }
      dispatch({ type: 'updateField', payload: { field, value } });
   };

   /**
    * fixed response used in testing mode
    *
    */
   const fixedVendingResponse = {
      firstName: 'GEOFREY BYEGEKA',
      lastName: '',
      meterNumber: '14235760049',
      purchaseAmount: 100,
      receipt: '2212/2649939',
      referenceId: 'VA15990223801951102',
      responseCode: 1,
      responseDesc: 'SUCCESSFUL',
      tariffInfo: '@ 89.0/kWh',
      tarrifName: 'Residential_Seq',
      token: '0297-0254-5508-5871-8792',
      transactionId: 'KA1599022409124699',
      units: 1,
   };
   /**
    * handle submit method to vend electricity
    * @param {*} e
    */
   const handleSubmit = (e) => {
      e.preventDefault();
      const { meterNumber, mobileNumber, amount } = state;
      let request = {
         meterNumber,
         mobileNumber,
         amount,
      };
      request.partnerId = savedUser.partnerId;
      setIsBuyingLoading(true);
      // For testingin purpose
      // ****************************************
      // let vendingResponse = fixedVendingResponse;
      // setValidated(false);
      // setShowReceipt(true);
      // setActive(false);
      // let notificationType = '';
      // let notification = '';
      // dispatch({
      //    type: 'vend',
      //    payload: {
      //       vendingResponse,
      //       notificationType,
      //       notification,
      //    },
      // });
      // setIsBuyingLoading(false);
      // ************************************
      // For production
      VendingService.vendElectricity(request)
         .then((res) => res.text())
         .then((data) => {
            let vendingResponse = ResponseParser.parseVendResponse(data);
            console.dir(vendingResponse);
            let notificationType = '';
            let notification = '';
            setIsBuyingLoading(false);
            if (vendingResponse.responseCode === 1) {
               setValidated(false);
               setShowReceipt(true);
               setActive(false);
            } else {
               setValidated(false);
               setActive(false);
               notificationType = 'danger';
               notification = vendingResponse.responseDesc;
               setShowReceipt(false);
            }
            dispatch({
               type: 'vend',
               payload: {
                  vendingResponse,
                  notificationType,
                  notification,
               },
            });
            getVendingSummary();
         })
         .catch((error) => {
            console.error(error);
            handleApiError(error);
         });
   };

   const getVendingSummary = () => {
      let { partnerId } = savedUser;
      VendingService.getSalesSummary({ partnerId })
         .then((res) => res.text())
         .then((data) => {
            let response = ResponseParser.parseSaleSummaryResponse(data);
            setAgentAccount({
               vendorNames: response.vendorNames,
               totalSalesCount: response.totalSalesCount,
               vendorAccountBalance: response.vendorAccountBalance,
               totalSalesAmount: response.totalSalesAmount,
               refillThresholdBalance: response.refillThresholdBalance,
               favorites: response.favorites,
               products: response.products,
            });
         })
         .catch((error) => {
            console.log(error);
            handleApiError(error);
         });
   };

   useEffect(getVendingSummary, []);

   return (
      <section className='section'>
         <DashBoard user={savedUser} account={agentAccount} />
         <div className='is-divider' data-content=''></div>
         <div className='columns'>
            <div className='column is-5 is-offset-1'>
               <form>
                  <div className='field'>
                     <label className='label'>Product</label>
                     <div className='control'>
                        <div className='select is-small'>
                           <select>
                              <option>Electricity</option>
                              <option>Airtime</option>
                           </select>
                        </div>
                     </div>
                  </div>
                  <div className='field'>
                     <label className='label'>Meter Number</label>
                     <div className='control'>
                        <input
                           className='input is-small'
                           name='meterNumber'
                           type='text'
                           value={state.meterNumber}
                           onChange={(e) => updateField(e.target.name, e.target.value)}
                           placeholder='Enter meter number'
                        />
                     </div>
                  </div>
                  <div className='field'>
                     <label className='label'>Mobile Number</label>
                     <div className='control'>
                        <input
                           className='input is-small'
                           name='mobileNumber'
                           type='text'
                           value={state.mobileNumber}
                           onChange={(e) => updateField(e.target.name, e.target.value)}
                           placeholder='Enter user mobile'
                           required
                        />
                     </div>
                  </div>
                  <div className='field'>
                     <label className='label'>Amount</label>
                     <div className='control'>
                        <input
                           className='input is-small'
                           name='amount'
                           type='text'
                           value={state.amount}
                           onChange={(e) => updateField(e.target.name, e.target.value)}
                           placeholder='Enter amount'
                        />
                     </div>
                  </div>
                  <div className='buttons'>
                     <button
                        type='button'
                        className={`button is-warning is-rounded ${
                           isValidateLoading ? 'is-loading' : ''
                        }`}
                        onClick={handleValidate}
                     >
                        Validate
                     </button>
                     <button
                        type='button'
                        className={`button is-success is-rounded ${
                           isBuyingLoading ? 'is-loading' : ''
                        }`}
                        onClick={handleSubmit}
                        disabled={!active}
                     >
                        <AiOutlineShoppingCart />
                        {'   '}Buy
                     </button>
                     <button
                        type='reset'
                        className='button is-light is-rounded'
                        onClick={handleReset}
                     >
                        Reset
                     </button>
                  </div>
               </form>
            </div>
            <div className='column is-5'>
               <div>
                  {validated && <CustomerCard customer={state.customerCheckResponse} />}
                  <br />
                  {showReceipt === true ? (
                     <Receipt title={'Token Receipt'} tokenReceipt={state.vendingResponse} />
                  ) : (
                     <Notification
                        notificationType={state.notificationType}
                        notification={state.notification}
                     />
                  )}
               </div>
            </div>
         </div>
      </section>
   );
}
